export const ModalUpdateShopifyThemeId = {
  update_shopify_theme_id_title: 'Update shopify theme id',
  update_shopify_theme_id_description_1: 'When customizing the theme, the data is updated to this theme id. Go to',
  update_shopify_theme_id_description_2: 'Online Store',
  update_shopify_theme_id_description_3: 'to get the theme id.',
  theme_removed_warning_title: 'Theme Alert: Update Required - Possible Deletion',
  theme_removed_warning_description: 'The theme you chose to sync Veda page was deleted. You should switch to another available theme',
  go_to_theme_area: 'Go to Themes area.',
} as const;
